module.exports = __webpack_public_path__ + "static/media/facebook.bb38784a.svg";